export default __webpack_public_path__ + "static/media/element_15.e07a2a6c.jpg";